import { Game } from '../../shared/game.model';
import { local } from '../../../mixins/environment';
import { availableGames, defaultGameDataMap, parseGameName } from '../../../mixins/games.commons';
import axios from 'axios';
import store from '../../index';
import { LeaderboardPlayer } from './models/leaderboard-player.model';
import { SearchPlayer } from './models/search-player.model';

export default {
  getConnectedGames(username) {
    const url = `${store.state.app.config.baseUrl}/api/profile/my_activities/get_list_conected_games`;

    if (!local) {
      return axios.get(url, {
        params: { name: username },
      }).then(({ data }) => {
        const list = Object.values(data.listConnectedGames);
        const gameList = availableGames.map(gameAlias => {
          const isConnected = list.findIndex(connectedGame => parseGameName(connectedGame.alias) === gameAlias) !== -1;
          return new Game({ ...defaultGameDataMap[gameAlias], connected: isConnected });
        });
        return gameList;
      }).catch(() => {
        throw new Error('error');
      });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const response = [{ alias: 'fortnite' }, { alias: 'league-of-legends' }, { alias: 'rocket-league' }];
        const gameList = availableGames.map(gameAlias => {
          const isConnected = response.findIndex(connectedGame => parseGameName(connectedGame.alias) === gameAlias) !== -1;
          return new Game({ ...defaultGameDataMap[gameAlias], connected: isConnected });
        });

        resolve(gameList);
      }, 1000);
    });
  },

  updateConnectedGames(listConnectedGame) {
    const list = Object.values(listConnectedGame);
    const gameList = availableGames.map(gameAlias => {
      const isConnected = list.findIndex(connectedGame => parseGameName(connectedGame.alias) === gameAlias) !== -1;
      return new Game({ ...defaultGameDataMap[gameAlias], connected: isConnected });
    });
    return gameList;
  },

  getGeneralData({ boomAccountId }) {
    const url = `${store.state.app.config.baseUrl}/api/v1/profiles`;

    if (!local) {
      return axios.get(
        url,
        { params: { boomAccountId }}
      ).then(({ data }) => {
        return data;
      }).catch(() => {
        throw new Error('error');
      });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const response = {
          _id: '5f2dc4e99800457eb3bf2935',
          boomAccountId: 9999998,
          avatar: 'https://avatarfiles.alphacoders.com/893/thumb-89303.gif',
          hubMembership: [{
            id: '4',
            name: 'HUB Testing',
          }],
          state: 'Texas',
          country: 'United States',
        };

        resolve(response);
      }, 2000);
    });
  },

  getLeaderboard(options) {
    const leaderboardType = options.leaderboardType;
    const url = `${store.state.app.config.baseUrl}/api/v1/leaderboard`;

    if (!local) {
      return axios.get(url, { params: { ...options }})
        .then(({ data }) => {
          if (!data.length) {
            return { list: [], newOffset: 0 };
          }

          const list = data.map(player => new LeaderboardPlayer({ ...player, leaderboardType }));
          const newOffset = list[list.length - 1].position;
          return { list, newOffset };
        }).catch(() => {
          throw new Error('error');
        });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const response = [];
        for (let i = 0; i < 15; i++) {
          response.push({
            boomAccountId: 9999999,
            name: `${options.game}Seadawg`,
            leaderboardPosition: i + 1,
            avatar: 'https://phoneky.co.uk/thumbs/screensavers/down/cartoon-anime/cutepikach_1QDbPL0n.gif',
            points: 2500,
            score: 999,
            leaderboardType,
            changeInPosition: 3,
          });
        }

        const list = response.map(player => new LeaderboardPlayer(player));
        const newOffset = list[list.length - 1].position;
        resolve({ list, newOffset });
      }, 800);
    });
  },

  getLeaderboardCurrentUserData({ boomAccountId, options }) {
    const leaderboardType = options.leaderboardType;
    const url = `${store.state.app.config.baseUrl}/api/v1/leaderboard`;

    if (!local) {
      return axios.get(url, { params: { boomAccountId, ...options, limit: 1 }})
        .then(({ data }) => {
          if (!data.length) {
            return null;
          }
          return new LeaderboardPlayer({ ...data[0], leaderboardType });
        }).catch(() => {
          throw new Error('error');
        });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const response = [{
          boomAccountId: 9999998,
          name: `${options.game}Seadawg`,
          avatar: 'https://phoneky.co.uk/thumbs/screensavers/down/cartoon-anime/cutepikach_1QDbPL0n.gif',
          points: 116220,
          leaderboardPosition: 5,
          displayText: '116220 points',
          changeInPosition: 70,
          score: 999,
          leaderboardType,
        }];

        const current = new LeaderboardPlayer(response[0]);
        resolve(current);
      }, 800);
    });
  },

  searchPlayers(options) {
    const url = `${store.state.app.config.baseUrl}/api/v1/users`;

    if (!local) {
      return axios.get(url, { params: { ...options }})
        .then(({ data }) => {
          const playerList = data.map(player => new SearchPlayer(player));
          return playerList;
        }).catch(() => {
          throw new Error('error');
        });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const response = [];
        for (let i = 0; i < 3; i++) {
          response.push({
            boomAccountId: 9999999,
            name: `${options.name}${i}`,
            leaderboardPosition: i + 1,
            avatar: 'https://phoneky.co.uk/thumbs/screensavers/down/cartoon-anime/cutepikach_1QDbPL0n.gif',
            score: 999,
          });
        }

        const list = response.map(player => new SearchPlayer(player));
        resolve(list);
      }, 800);
    });
  },

};
